import { useEffect } from 'react';
import { createFileRoute, useRouter, useNavigate } from '@tanstack/react-router';
import { http } from '@frontend/fetch';
import { useAlert } from '@frontend/design-system';
import { Loader } from '../../../components';
import { useIntegrationsDashboardShallowStore } from '../../../store';

const SignInCallback = () => {
  const auth = Route.useRouteContext({ select: (ctx) => ctx.auth });
  const params = Route.useParams();
  const alert = useAlert();
  const router = useRouter();
  const navigate = useNavigate();
  const { isUserAuthenticated, setIsUserAuthenticated } = useIntegrationsDashboardShallowStore(
    'isUserAuthenticated',
    'setIsUserAuthenticated'
  );

  useEffect(() => {
    if (params && !isUserAuthenticated) {
      auth
        .handleCallback()
        .then((tokens) => {
          if (tokens) {
            setIsUserAuthenticated(true);
            http.setAuthorizationHeader(tokens.weaveToken);
          }
        })
        .catch((e) => {
          console.error(e);
          alert.error({
            message: 'There was an error during authentication. Please try again.',
            autoDismissAfter: 2000,
          });
        });
    } else {
      const redirect = sessionStorage.getItem('redirect');
      setIsUserAuthenticated(true);
      if (redirect) {
        sessionStorage.removeItem('redirect');
        navigate({ to: redirect });
      } else {
        navigate({ to: '/dashboard' });
      }
    }
  }, [isUserAuthenticated, auth, params, router.history]);

  return <Loader />;
};

export const Route = createFileRoute('/_public/sign-in_/callback')({
  component: SignInCallback,
});
